module.exports = __webpack_public_path__ + "img/logo_8V.84bfb6e3.png";